<app-expandable-section-box
  [title]="'Topics'"
  [isExpandable]="false"
  class="w-1/2"
>
  <div class="flex flex-col gap-y-[0.3rem] py-0 px-2 flex-1" expandedContent>
    <mat-form-field appearance="outline">
      <input
        matInput
        class="pb-[0.1rem]"
        [formControl]="searchTopicText"
        placeholder="Search for a topic"
        [matAutocomplete]="topicAutocomplete"
      />
      <mat-autocomplete
        #topicAutocomplete="matAutocomplete"
        (optionSelected)="addTopic($event.option.value)"
      >
        <ng-container *ngIf="topicResults">
          <ng-container
            *ngIf="topicResults?.length && !!searchTopicText; else noData"
          >
            <mat-option *ngFor="let topic of topicResults" [value]="topic">
              {{ topic.displayName }}
            </mat-option>
          </ng-container>
        </ng-container>
        <ng-template #noData>
          <mat-option *ngIf="!!searchTopicText" disabled>
            No results
          </mat-option>
        </ng-template>
      </mat-autocomplete>
    </mat-form-field>
    <div class="pb-4 gap-x-2">
      <div
        class="px-0 py-2 m-0 border-t border-t-project-100"
        *ngIf="selectedTopics?.length"
      >
        <ng-container
          *ngFor="
            let selectedTopic of selectedTopics;
            odd as isOdd;
            even as isEven
          "
        >
          <div
            class="flex justify-between px-4 py-2"
            data-testid="selectedTopic"
            [ngClass]="{
              'bg-project-2500': isEven,
              'bg-project-2600': isOdd
            }"
          >
            <div class="flex items-center flex-1 space-x-1">
              <span>{{ selectedTopic?.displayName }}</span>
            </div>
            <button
              class="text-base border-none bg-none text-project-100 hover:cursor-pointer hover:text-project-2700"
              data-testid="selectedTopicDeleteBtn"
              title="Remove Topic"
              (click)="removeTopic(selectedTopic)"
            >
              <i class="icon icon-minus-circle"></i>
            </button>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</app-expandable-section-box>

<app-expandable-section-box
  [title]="'Tags'"
  [isExpandable]="false"
  class="w-1/2 pt-5"
>
  <div class="flex flex-col gap-y-[0.3rem] py-0 px-2 flex-1" expandedContent>
    <mat-form-field appearance="outline">
      <input
        matInput
        class="pb-[0.1rem]"
        [formControl]="searchTagText"
        placeholder="Search for a tag"
        [matAutocomplete]="tagAutocomplete"
      />
      <mat-autocomplete
        #tagAutocomplete="matAutocomplete"
        (optionSelected)="addTag($event.option.value)"
      >
        <ng-container *ngIf="tagResults">
          <ng-container
            *ngIf="tagResults?.length && !!searchTagText; else noData"
          >
            <mat-option *ngFor="let tag of tagResults" [value]="tag">
              {{ tag.text }}
            </mat-option>
          </ng-container>
        </ng-container>
        <ng-template #noData>
          <mat-option *ngIf="!!searchTagText" disabled> No results </mat-option>
        </ng-template>
      </mat-autocomplete>
    </mat-form-field>
    <div class="pb-4 gap-x-2">
      <div
        class="px-0 py-2 m-0 border-t border-t-project-100"
        *ngIf="selectedTags?.length"
      >
        <ng-container
          *ngFor="let selectedTag of selectedTags; odd as isOdd; even as isEven"
        >
          <div
            class="flex justify-between px-4 py-2"
            data-testid="selectedTag"
            [ngClass]="{
              'bg-project-2500': isEven,
              'bg-project-2600': isOdd
            }"
          >
            <div class="flex items-center flex-1 space-x-1">
              <span>{{ selectedTag?.text }}</span>
            </div>
            <button
              class="text-base border-none bg-none text-project-100 hover:cursor-pointer hover:text-project-2700"
              data-testid="selectedTagDeleteBtn"
              title="Remove Tag"
              (click)="removeTag(selectedTag)"
            >
              <i class="icon icon-minus-circle"></i>
            </button>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</app-expandable-section-box>
